// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-link[data-v-34433436] {\r\n  font-size: 12px;\n}\n.linkMiddle[data-v-34433436] {\r\n  padding: 0 8px;\r\n  color: #dddddd;\n}\n.table-top[data-v-34433436] {\r\n  margin-top: 20px;\n}\n.pagination[data-v-34433436] {\r\n  padding-bottom: 20px;\n}\r\n", ""]);
// Exports
module.exports = exports;
